import { deInitProperties } from '../common/index';
import { getRowHeight, getCell, isHiddenRow, isHiddenCol } from '../../workbook/base/index';
import { attributes } from '@syncfusion/ej2-base';
import { getCellAddress, getCellIndexes, skipHiddenIdx, isImported } from '../../workbook/common/index';
/**
 * RowRenderer module is used for creating row element
 *
 * @hidden
 */
export class RowRenderer {
    constructor(parent) {
        this.parent = parent;
        this.element = this.parent.createElement('tr');
        this.cellRenderer = parent.serviceLocator.getService('cell');
        this.parent.on(deInitProperties, this.initProps, this);
    }
    render(index, isRowHeader, preventHiddenCls) {
        const row = this.element.cloneNode();
        const sheet = this.parent.getActiveSheet();
        if (index === undefined) {
            row.classList.add('e-header-row');
            return row;
        }
        row.classList.add('e-row');
        if (!this.bottomBorderWidth) {
            let width = 1;
            if (window.devicePixelRatio % 1 > 0) {
                const pointValue = (1 * window.devicePixelRatio) % 1;
                width = 1 + (pointValue ? ((pointValue > 0.5 ? (1 - pointValue) : -1 * pointValue) / window.devicePixelRatio) : 0);
            }
            this.bottomBorderWidth = width;
        }
        const rowHeight = getRowHeight(sheet, index, true);
        const actualRowHgt = getRowHeight(sheet, index);
        const rowStyles = {
            height: `${rowHeight}px`,
            lineHeight: (actualRowHgt < 20) ?
                (rowHeight > this.bottomBorderWidth ? `${rowHeight - this.bottomBorderWidth}px` : '0px') : ''
        };
        Object.assign(row.style, rowStyles);
        attributes(row, { 'aria-rowindex': (index + 1).toString() });
        if (isRowHeader && !preventHiddenCls) {
            if (actualRowHgt < 20) {
                const width = 4 + (this.bottomBorderWidth - 1);
                row.style.lineHeight = rowHeight >= width ? `${rowHeight - width}px` :
                    (rowHeight > this.bottomBorderWidth ? `${rowHeight - this.bottomBorderWidth}px` : '0px');
                if (!row.classList.contains('e-reach-fntsize')) {
                    row.classList.add('e-reach-fntsize');
                }
            }
            if (isHiddenRow(sheet, index + 1) && !isHiddenRow(sheet, index - 1)) {
                row.classList.add('e-hide-start');
            }
            if (index !== 0 && isHiddenRow(sheet, index - 1) && !isHiddenRow(sheet, index + 1)) {
                row.classList.add('e-hide-end');
            }
        }
        return row;
    }
    refresh(index, pRow, hRow, header, preventHiddenCls) {
        const sheet = this.parent.getActiveSheet();
        let row;
        if (header) {
            row = this.render(index, header, preventHiddenCls);
            this.cellRenderer.renderRowHeader(index, row);
        }
        else {
            let i;
            let len;
            const updateCells = () => {
                while (i <= len) {
                    if (!isHiddenCol(sheet, i)) {
                        this.cellRenderer.render({ colIdx: i, rowIdx: index, cell: getCell(index, i, sheet), address: getCellAddress(index, i),
                            lastCell: i === len, row: row, hRow: hRow, isHeightCheckNeeded: true, pRow: pRow, first: index === this.parent.viewport.topIndex && skipHiddenIdx(sheet, index, true) !==
                                skipHiddenIdx(sheet, 0, true) ? 'Row' : '', skipFormatCheck: isImported(this.parent), checkCF: true });
                    }
                    i++;
                }
            };
            const frozenCol = this.parent.frozenColCount(sheet);
            if (frozenCol) {
                row = hRow;
                i = getCellIndexes(sheet.topLeftCell)[0];
                len = frozenCol - 1;
                updateCells();
            }
            row = this.render(index, header, preventHiddenCls);
            i = this.parent.viewport.leftIndex + frozenCol;
            len = this.parent.viewport.rightIndex;
            updateCells();
        }
        return row;
    }
    initProps() {
        this.bottomBorderWidth = null;
    }
    /**
     * Clears the internal properties of RowRenderer module.
     *
     * @returns {void}
     */
    destroy() {
        this.parent.off(deInitProperties, this.initProps);
        if (this.element) {
            this.element.remove();
        }
        if (this.bottomBorderWidth) {
            this.bottomBorderWidth = null;
        }
        this.parent = null;
        this.element = null;
    }
}
